import * as React from 'react';
import { ReactElement } from 'react';
import BasicModal from 'components/common/modal/BasicModal';
import styled from 'styled-components';
import { Button, TextField, Typography } from '@material-ui/core';
import { ColorText } from 'components/plansales/billing/detail/invoice/InvoiceTableRenderer';

interface Props {
  commentValue: string;
  isSubmitDisabled: boolean;
  onChangeComment: (value: string) => void;
  onSubmit: () => Promise<void>;
  onClose: () => void;
}

const DeleteBackOrderModal = ({
  commentValue,
  isSubmitDisabled,
  onChangeComment,
  onSubmit,
  onClose,
}: Props): ReactElement => {
  return (
    <BasicModal
      open={true}
      onClose={onClose}
      title="Delete the reserved plan"
      actionButton={
        <>
          <Button variant={'text'} color={'default'} onClick={onClose}>
            Cancel
          </Button>
          <Button variant={'text'} color={'primary'} onClick={onSubmit} disabled={isSubmitDisabled}>
            Confirm
          </Button>
        </>
      }
    >
      <Typography variant="subtitle1">
        Are you sure you want to delete the reserved plan?
      </Typography>
      <CommentWrapper>
        <Typography>
          Comment <ColorText color={'red'}> *</ColorText>
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant={'outlined'}
          value={commentValue}
          onChange={e => onChangeComment(e.target.value)}
          inputProps={{ maxLength: 500 }}
          placeholder="Please enter the reason for this change. "
        />
      </CommentWrapper>
    </BasicModal>
  );
};

export default DeleteBackOrderModal;

const CommentWrapper = styled.div`
  margin: ${props => props.theme.spacing(3)}px 0px;
`;
